import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, OnDestroy, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageService } from './shared/services/local-storage.service';
import { TagManagerService } from './shared/services/tag-manager.service';
import { UsersService } from './shared/services/users.service';
import { InactivityService } from './shared/services/inactivity.service';
declare global {
	interface Window {
		dataLayer: any;
	}
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'RoD-App';

	constructor(
		private router: Router,
		private localStorage: LocalStorageService,
		private tagManager: TagManagerService,
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId: Object,
		private userService: UsersService,
		private inactivityService: InactivityService
	) {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (isPlatformBrowser(this.platformId)) {
					this.tagManager.setTagManager({
						event: 'pageview',
						location: document.location.origin,
						pagetype: document.location.search,
						path: document.location.pathname,
						referrer: document.referrer,
						title: document.title,
					});
				}

				this.verifySession();

				if (this.userService.userId) {
					this.tagManager.setTagManager({
						event: 'UserData',
						user_id: this.userService.userId?.toString(),
					});
				}

				if (isPlatformBrowser(this.platformId)) {
					this.document.body.classList.remove('modal-open');
				}
			}
		});
	}

	ngOnInit() {
		this.verifySession();

		if (!isPlatformBrowser(this.platformId)) return;

		if (this.router.url.includes('/conta/login')) {
			return;
		}
	}

	ngOnDestroy() {
		this.inactivityService.stopWatching();
	}

	verifySession() {
		let sessionId = this.localStorage.getItem('RoD-SessionId');
		if (sessionId == null) this.localStorage.setItem('RoD-SessionId', this.userService.newGuid());
	}

	emitEvent() {
		this.tagManager.setTagManager({
			event: 'gaEvent',
			eventCategory: 'contato',
			eventAction: 'clique',
			eventLabel: 'whatsapp',
		});
	}
}
